<template>
  <el-main>
    <banner></banner>
    <com-intr></com-intr>
    <com-service></com-service>
    <contact-us></contact-us>
    <get-more></get-more>
  </el-main>
</template>

<script>
import Banner from '../../components/Banner'
import GetMore from '../../components/GetMore'
import ComIntr from './components/ComIntr'
import TitleText from './components/TitleText'
import ComService from './components/ComService'
import ContactUs from './components/ContactUs'

export default {
  name: 'AboutUs',
  components: {GetMore, Banner, ComIntr, TitleText, ComService, ContactUs}
}
</script>

<style scoped lang="stylus">
  .el-main
    padding: 20px 0
    margin: 0 auto

</style>



// WEBPACK FOOTER //
// src/pages/aboutUs/AboutUs.vue